// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"05d4cfcd","453":"6114242e","707":"b1f80afe"}[chunkId] + ".chunk.js";
};